import { AudioMix } from "../../Api/Types/audio-mix";
import { EnvType } from "../../Api/services";
import { TranskodeVideoProfile } from "../../Api/Types/transkode-video-profile";
import { UserDataCustomType } from "../../Api/Types/user-data-custom-type";
import { UserDataStatus } from "../../Api/Types/user-data-status";
import { UserDataType } from "../../Api/Types/user-data-type";
import { PermissionType } from "../../Api/Types/permission-type";

/*
Put here all global consts used into app.
*/
export default abstract class GlobalConst {
  static readonly LOADING_TEXT: string = "We are loading...";
  static readonly dbBaseTypeBeginning: string = "VDM.AirLab.Sdk.Core.Database.Types.";
  static readonly dbBaseTypeEnding: string = ", VDM.AirLab.Sdk.Core";
  static readonly userDataTypes: { label: string; value: UserDataType }[] = [
    { label: "Source File", value: UserDataType.SourceFile },
    { label: "Delivery File", value: UserDataType.DeliveryFile },
    { label: "Work File", value: UserDataType.WorkFile },
  ];
  static readonly userDataStatuses: { label: string; value: UserDataStatus }[] = [
    { label: "Ready", value: UserDataStatus.Ready },
    { label: "Waiting for Work", value: UserDataStatus.WaitingForWork },
    { label: "Validation in Progress", value: UserDataStatus.ValidationInProgress },
  ];
  static readonly userDataCustomTypes: { label: string; value: UserDataCustomType }[] = [
    { label: "Subtitle Full", value: UserDataCustomType.SubtitleFull },
    { label: "Subtitle Partial", value: UserDataCustomType.SubtitlePartial },
    { label: "Subtitle Full without Partial", value: UserDataCustomType.SubtitleFullWithoutPartial },
  ];
  static readonly DEFAULT_REDIRECT_PATH: string = "/catalog";
  static readonly DEFAULT_TREE_DEPTH: number = 4;
  static readonly SEARCH_THROTTLE_DELAY_MS: number = 450;
  static readonly MOMENT_DATE_FORMAT_FULL: string = "YYYY/MM/DD HH:mm";
  static readonly MOMENT_DATE_FORMAT_DATENOHOURS: string = "YYYY/MM/DD";
  static readonly MOMENT_DATE_FORMAT_DATENOHOURS_FR: string = "DD/MM/YYYY";
  static readonly MOMENT_DATE_FORMAT_HOURS: string = "HH:mm";
  static readonly MOMENT_DATE_FORMAT_HOURSWITHSECS: string = "HH:mm:ss";
  static readonly MOMENT_DATE_FORMAT_YEARONLY: string = "YYYY";
  static readonly ZENDESK_BASE_HC_URL: string = "https://vdmcare.zendesk.com/hc/en-us/requests";
  static readonly ZENDESK_TYPOLOGY_FIELD_NAME: string = "Typologie mediaspot®";
  static readonly USERGUIDING_RC_ID: number = 4309;
  static readonly MAX_CHILDREN: number = 100;
  static readonly BROWSER_IMG_SPRITE_COUNT: number = 32;
  static readonly BROWSER_IMG_SPRITE_WIDTH_PX: number = 300;
  static readonly BROWSER_IMG_SPRITE_HEIGHT_PX: number = 168;
  static readonly EXPORT_DELIMITER: string = "|";
  static readonly URL_APP: string = "https://app.mediaspot.io";
  static readonly URL_WWW: string = "https://mediaspot.io";
  static readonly ELEVATION_RESPONSE_OBJECT_ID: number = -100;
  static readonly MAX_FILES_COUNT_HTTP: number = 100;
  static readonly MAX_FILE_SIZE_HTTP_UPLOAD: number = 10000000000;
  static readonly MAX_FILE_SIZE_HTTP_DOWNLOAD: number = 10737418240;
  static readonly HTTP_UPLOAD_POOL_SIZE: number = 10;
  static readonly HTTP_UPLOAD_TIMEOUT_MS: number = 500;
  static readonly DRIVE_FEATURE_NAME: string = "Drive";
  static readonly SHARE_OVERLAYTEXT_MIN_CHARS: number = 2;
  static readonly FORM_SECTION_SUMMARY_DELIMITER = " · ";
  static readonly BUNDLE_MAKER_ALLOWED_VIDEO_PROFILES = [
    TranskodeVideoProfile.SD,
    TranskodeVideoProfile.HD,
    TranskodeVideoProfile.UHD,
  ];
  static readonly BROADCASTER_ID_NEEDED = "Please add a broadcasterId!";
  static readonly DEFAULT_SCALE: number = 300;
  static readonly MINIMUM_SCALE: number = 100;
  static readonly MAXIMUM_SCALE: number = 400;
  static readonly SCALE_STEP: number = 100;
  static readonly HEADER_HEIGHT: number = 48;
  static readonly HEADING_HEIGHT: number = 300;
  static readonly HEADING_HEIGHT_COLLAPSED: number = 48;
  static readonly UI_FEATURES: string[] = ["Audio Tracks List"];
  static readonly WORLD_CULTURE_ID: number = 103;
  static readonly MAX_DRIVE_DOWNLOADABLE_FILES: 100;
  static readonly ATMOS_RENDERER_ALLOWED_AUDIO_MIXES = [AudioMix.Mix_2_0, AudioMix.Mix_5_1, AudioMix.Mix_7_1];
  static readonly ZENDESK_HELP_CENTER_URL: string = "https://vdmcare.zendesk.com/access/";
  static readonly RIGHT_PANEL_CLASSNAME: string = "resizable-right";
  static readonly LEFT_PANEL_CLASSNAME: string = "resizable-left";
  static readonly BASKET_DRAWER_WIDTH: number = 320;
  static readonly ZENDESK_ENABLED: boolean = true; //(process.env.REACT_APP_ENV as EnvType) !== "prod"
  static readonly TITLE_STATUS_TAGNAME: string = "bundleTitleStatus";
  static readonly EXTERNAL_ACCESS_ALLOWED_PERMISSIONS: PermissionType[] = [
    PermissionType.Access,
    PermissionType.Comment,
    PermissionType.CreateObject,
    PermissionType.Download,
  ];
  static readonly EXTERNAL_ACCESS_MANDATORY_PERMISSIONS: PermissionType[] = [PermissionType.Access];
  static readonly REPORTING_DAYS_BEFORE_PURGE_SOURCE_ADAM: number = 21;
}
